/* eslint-disable import/prefer-default-export */
/* eslint-disable camelcase */
import axios from 'axios';
import { API } from '../api';
import { Push } from './push';
import { URL } from '../url';
import { isClient } from './isClient';

const { getUserDetail } = API;

export const isLogin = () => {
  if (isClient()) {
    const access_token = localStorage.getItem('access_token');
    if (access_token) {
      axios.request({
        url: getUserDetail,
        method: 'get',
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }).then((res) => {
        const { success } = res.data;
        if (success) {
          Push(URL.auth + access_token);
        }
      }).catch(() => {
        localStorage.removeItem('access_token');
      });
    }
  }
};
